import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

// Section 1
const CONSENT_DATE = 'consent_date'
const CONSENT = 'consent'
const CONSENT_REASON = 'consent_reason'

const today = new Date()
today.setHours(0, 0, 0, 0)

/**
 * Form model
 */
const formModel = () => {
  return {
    [CONSENT_DATE]: {
      label: `Date of consent`,
      name: CONSENT_DATE,
      required: true,
    },
    [CONSENT]: {
      label: `Consent`,
      name: CONSENT,
    },
    [CONSENT_REASON]: {
      label: `Reason`,
      name: CONSENT_REASON,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [CONSENT_DATE]: null,
  [CONSENT]: false,
  [CONSENT_REASON]: '',
}


export default formModel
